import { render, staticRenderFns } from "./QutaRawMater.vue?vue&type=template&id=63458573&scoped=true&"
import script from "./QutaRawMater.vue?vue&type=script&lang=js&"
export * from "./QutaRawMater.vue?vue&type=script&lang=js&"
import style0 from "./QutaRawMater.vue?vue&type=style&index=0&id=63458573&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63458573",
  null
  
)

export default component.exports